module.exports = __webpack_public_path__ + "static/media/OrientaçõesPreenchimentoMassaInicial.175b3acc.pdf";